module.exports = __webpack_public_path__ + "static/assets/51adf4a45cbacf743c3ee538e432fed2.png";